import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function FinalCTA() {
  return (
    <section className="relative overflow-hidden bg-ds-plum text-white" data-testid="landing-final-cta">
      <div className="contour-light absolute inset-0" aria-hidden="true" />
      <div className="container-x relative py-16 md:py-20 grid lg:grid-cols-12 gap-8 items-center">
        <div className="lg:col-span-8" data-reveal>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-semibold leading-[1.15]">The best career conversations start with a good map.</h2>
          <p className="mt-4 text-[17px] text-white/90 max-w-xl leading-relaxed">Take the first step today. One calm hour now can make the big choices ahead feel a lot lighter.</p>
        </div>
        <div className="lg:col-span-4 flex lg:justify-end">
          <Link to="/signup" className="ds-btn bg-ds-amber text-ds-plumdeep hover:bg-[#e8933d]" data-testid="final-cta-button">Start the journey <ArrowRight className="h-4 w-4" /></Link>
        </div>
      </div>
    </section>
  );
}
